import { subDays } from 'date-fns';

import { constants } from './../activity';

const formatDate = (date) => date.slice(5).replace('-', '/'); // mm/DD

export const serializeActivityData = (
  activity,
  lastNumberOfDays = constants.CHARTS_DATA_PERIOD,
) => {
  if (!activity || !activity.datestamp) {
    return [];
  }

  return activity.datestamp
    .map((datestamp, index) => ({
      name: formatDate(datestamp),
      tests_by_day: activity.jobs[index],
      peak_vm_ccy: activity.ccy_exec_peak[index],
    }))
    .slice(-1 * lastNumberOfDays);
};

// Takes last _numberOfDays_ days  from the array and produces a series of data based on it.
// Then takes another _numberOfDays_, and so on, up to _periods_ times, so that it can be
// presented as multiple Lines on a single chart.
// Refer to the test file for an example.
export const serializeMultiActivityData = (activity, numberOfDays = 7, periods = 1) => {
  if (!activity || !activity.datestamp) {
    return [];
  }

  const totalCount = activity.datestamp.length;
  const activityMap = [];

  for (let day = 0; day < numberOfDays; day += 1) {
    const dataPoint = {
      name: numberOfDays - day,
    };

    for (let period = 0; period <= periods - 1; period += 1) {
      const dataPointIndex = totalCount - 1 - period * numberOfDays - day;

      if (activity.datestamp[dataPointIndex]) {
        dataPoint[`datestamp${periods - period}`] = formatDate(activity.datestamp[dataPointIndex]);
      }
      if (activity.jobs && Number.isFinite(activity.jobs[dataPointIndex])) {
        dataPoint[`tests_by_day${periods - period}`] = activity.jobs[dataPointIndex];
      }
      if (activity.ccy_exec_peak && Number.isFinite(activity.ccy_exec_peak[dataPointIndex])) {
        dataPoint[`peak_vm_ccy${periods - period}`] = activity.ccy_exec_peak[dataPointIndex];
      }
    }

    activityMap.unshift(dataPoint);
  }

  return activityMap;
};

export const serializeTabularData = (entries, lastNumberOfDays = constants.CHARTS_DATA_PERIOD) => (
  entries
    .map(([teamId, value]) => ([teamId, {
      ccy_exec_peak: Math.max(...value.ccy_exec_peak.slice(-1 * lastNumberOfDays)),
      jobs: value.jobs.slice(-1 * lastNumberOfDays).reduce((current, acc) => current + acc, 0),
    }]))
);

export const xDaysAgo = (x) => Math.floor(subDays(new Date(), x).getTime() / 1000);

export const normalizeName = (name) => name.toLowerCase().replace(/\s/g, '-');
export const generateReportName = ({
  extension = 'csv', params, reportType, rootSection,
} = {}) => {
  const name = [
    ...(rootSection ? [normalizeName(rootSection)] : []),
    ...(reportType ? [normalizeName(reportType)] : []),
    ...(params ? [normalizeName(params).join('--')] : []),
    Math.floor(new Date().getTime() / 1000),
  ].join('__');
  return `${name}.${extension}`;
};

export default {
  serializeActivityData,
  serializeMultiActivityData,
  serializeTabularData,
  xDaysAgo,
  normalizeName,
  generateReportName,
};
